export default __webpack_public_path__ + "static/media/in-person.62981ecb.svg";